'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var CREDENTIAL_NAME_MAX_LENGTH = exports.CREDENTIAL_NAME_MAX_LENGTH = 260;
var PLATFORMS = exports.PLATFORMS = ['android', 'ios'];
// Source: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
var POLICY_EMAIL = exports.POLICY_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var POLICY_PHONE = exports.POLICY_PHONE = /^[0-9]+$/;
var USER_AGE_MAX = exports.USER_AGE_MAX = 113;
var USER_AGE_MIN = exports.USER_AGE_MIN = 16;
var USER_EMAIL_MAX_LENGTH = exports.USER_EMAIL_MAX_LENGTH = 255;
var USER_LOCATION_MAX_LENGTH = exports.USER_LOCATION_MAX_LENGTH = 255;
var USER_NAME_MAX_LENGTH = exports.USER_NAME_MAX_LENGTH = 128;